import { useState } from 'react';

import BpkLargeAirlineIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/airline';
import BpkImage from '@skyscanner-internal/backpack-web/bpk-component-image';

import STYLES from './AirlineIcon.module.scss';

interface AirlineIconProps {
  airlineImage: string;
}

const AirlineIcon = ({ airlineImage }: AirlineIconProps) => {
  const [showDefault, setShowDefault] = useState(false);

  const onError = () => {
    setShowDefault(true);
  };

  return showDefault ? (
    <BpkLargeAirlineIcon className={STYLES.AirlineIcon__image} />
  ) : (
    <BpkImage
      className={STYLES.AirlineIcon__image}
      src={airlineImage}
      aspectRatio={24 / 24}
      altText="airline_image"
      onError={onError}
    />
  );
};

export default AirlineIcon;
